import socket from '@/plugins/socket'
import ScoreType from '@/store/model/sport/sport/ScoreType'
import store from '@/store'

export default {
  namespaced: true,
  state: {
    list: []
  },
  mutations: {
    set: (state, datas) => {
      state.list.splice(0)
      datas.forEach(item => { state.list.push(new ScoreType(item)) })
    }
  },
  actions: {
    load (state) { socket.get('SportSportScoretype', 'Sport/ScoreType/set') }
  },
  getters: {
    get: (state) => (id) => state.list.find(item => item.id === id),
    search: (state) => (roundTypeId, eventUnitId, disciplineId) => state.list.filter((item) => {
      const helpers = store.getters['Sport/ScoreTypeHelper/search'](roundTypeId, eventUnitId, disciplineId)
      const ids = helpers.map(helper => helper.scoreTypeId)
      return ids.indexOf(item.id) >= 0
    })
  }
}
